import Card from '_app/components/Card'
import {useCheckoutContext} from '../hooks'
import {DeliveryDetailsCard} from './DeliveryDetailsCard'
import {DeliveryOptionCard} from './DeliveryOptionCard'
import {useEffect} from 'react'

export const DeliveryCard = ({ data, cancelAuthorizationCard }) => {
  const { selectedShippingMethod } = useCheckoutContext()
    // useEffect(() => {
    //     if (selectedShippingMethod) {
    //         cancelAuthorizationCard()
    //     }
    // }, [selectedShippingMethod])
  return (
    <Card mb={6}>
      <DeliveryOptionCard data={data} />
      {selectedShippingMethod && <DeliveryDetailsCard />}
    </Card>
  )
}
